export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7594.b2aabc61.jpg";